import { SetStateAction } from "react";
import { Button, ButtonGroup, Col, Row } from "reactstrap";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import { ReactGlobals, TreeNode } from "../Types";

const WebsiteNode = (
  node: TreeNode,
  globals: ReactGlobals,
  load_node: (new_id: string, new_type: string) => void,
  handleTempContentChange: (event: {
    target: { value: SetStateAction<string> };
  }) => void
) => {
  return (
    <>
      <Row>
        <Col>
          <Markdown remarkPlugins={[remarkGfm, remarkBreaks]}>
            {globals.temporaryContent}
          </Markdown>
        </Col>
        <Col xs="auto">
          <ButtonGroup vertical>
            {node.Children.map((child: TreeNode) => (
              <Button
                key={Math.random().toString() + node.ID}
                outline
                style={{
                  textAlign: "left",
                }}
                onClick={() => {
                  load_node(child.ID, child.Type);
                }}
              >
                {child.Name.length > 30
                  ? child.Name.substring(0, 28) + "..."
                  : child.Name}
              </Button>
            ))}
          </ButtonGroup>
        </Col>
      </Row>
    </>
  );
};

export function add_Website_to_dicts(
  constuctor_dict: Map<
    string,
    (
      node: TreeNode,
      globals: ReactGlobals,
      load_node: (new_id: string, new_type: string) => void,
      handleTempContentChange: (event: {
        target: { value: SetStateAction<string> };
      }) => void
    ) => JSX.Element
  >,
  type_prompt_dict: Map<string, string[]>,
  type_adding_dict: Map<string, string[]>,
  type_depth_dict: Map<string, number>
) {
  constuctor_dict.set("Website", WebsiteNode);
  type_prompt_dict.set("Website", [
    "Improve",
    "More formal",
    "More casual",
    "More academic",
  ]);
  type_adding_dict.set("Website", [
    "Website",
    "Structure",
    "Canvas",
    "Player",
    "SR Characters",
  ]);
  type_depth_dict.set("Website", 1);
}

export default WebsiteNode;
